import { ReactNode } from "react";
import classNames from "classnames";

type MemberlinkWrapperArgs = {
  url?: string;
  className?: string;
  children: ReactNode;
};

export default function MemberlinkWrapper({
  url,
  className,
  children,
}: MemberlinkWrapperArgs) {
  return url ? (
    <a className={classNames("member-link", className)} href={url} aria-hidden>
      {children}
    </a>
  ) : (
    <span className={classNames("member-link", className)}>{children}</span>
  );
}
